var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MovimentiMagazzino',{attrs:{"id_magazzino":_vm.id_magazzino,"id_articolo":_vm.id_articolo}})
}
var staticRenderFns = []

export { render, staticRenderFns }